import type { ReactElement, ReactPortal } from 'react';
import { TrackingDetailsContainer, TrackingDetailsInnerContainer } from './TrackingDetailsLayout.styles';

interface ITrackingDetailsLayoutProps {
  isDesktopPMT: boolean;
  showDetailsView: boolean;
  smeHeaderImage: ReactElement | null;
  header: ReactElement | ReactPortal;
  trackingEventCard: ReactElement;
  ad: ReactElement | null;
  trackingEventList: ReactElement | null;
  ratingSection: ReactElement | null;
  orderSection: ReactElement | null;
  merchantSection: ReactElement | null;
  trackingCarrierSection: ReactElement | null;
  affiliateSection?: ReactElement | null;
  footerImage?: ReactElement;
}

type TTrackingDetailsHeaderLayoutProps = Pick<ITrackingDetailsLayoutProps, 'smeHeaderImage' | 'header'> & {
  isDesktop: boolean;
};
const TrackingDetailsHeaderLayout = ({ isDesktop, header, smeHeaderImage }: TTrackingDetailsHeaderLayoutProps) => {
  if (isDesktop)
    return (
      <>
        {smeHeaderImage}
        {header}
      </>
    );

  return (
    <>
      {header}
      {smeHeaderImage}
    </>
  );
};

export const TrackingDetailsLayout = ({
  isDesktopPMT,
  showDetailsView,
  smeHeaderImage,
  header,
  trackingEventCard,
  ad,
  trackingEventList,
  ratingSection,
  orderSection,
  merchantSection,
  trackingCarrierSection,
  affiliateSection,
  footerImage,
}: ITrackingDetailsLayoutProps) => {
  if (!showDetailsView && !isDesktopPMT) return null;

  return (
    <>
      <TrackingDetailsContainer>
        <TrackingDetailsHeaderLayout isDesktop={isDesktopPMT} smeHeaderImage={smeHeaderImage} header={header} />
        <TrackingDetailsInnerContainer>
          {trackingEventCard}
          {ad}
          {ratingSection}
          {orderSection}
          {merchantSection}
          {trackingEventList}
          {trackingCarrierSection}

          {!isDesktopPMT && affiliateSection}
        </TrackingDetailsInnerContainer>
      </TrackingDetailsContainer>

      {isDesktopPMT && affiliateSection}
      {footerImage}
    </>
  );
};
